import type { BlogPost } from "./blog";

export const BLOG_GUIDE_PART3: BlogPost[] = [
  {
    "slug": "chto-delat-peterburg-krome-muzeev",
    "title": "Что делать в Петербурге кроме музеев",
    "metaTitle": "Что делать в Петербурге кроме музеев 2026 | Паруса на крыше",
    "metaDescription": "Чем заняться в Петербурге помимо музеев: прогулки, рестораны, рынки, крыши, театры.",
    "keywords": "что делать петербург кроме музеев, петербург не музей что посмотреть, петербург без музеев",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "«Я уже всё видел в Эрмитаже» — и что теперь? Петербург гораздо богаче, чем его музеи. Расскажем, что делать в городе за пределами выставочных залов.",
    "sections": [
      {
        "heading": "Петербург за пределами музеев",
        "body": "Набережные и мосты: лучший Петербург — не в залах, а вдоль воды. Рынки: Некрасовский фермерский рынок, Апраксин двор. Кофейная сцена: specialty-кофейни Петербурга — одни из лучших в России. Гастрономия: рестораны с локальной кухней и авторскими шефами. Театры: Мариинский, Михайловский, Александринский. Дворы-колодцы: нетуристический Петербург.",
        "list": [
          "Набережные: лучший вид на город — у воды",
          "Рынки: Некрасовский — фермерский рынок",
          "Кофейни: specialty-культура высокого уровня",
          "Театры: опера и балет — петербургская традиция"
        ]
      },
      {
        "heading": "Гастрономия как способ познать город",
        "body": "Еда — лучший способ познать культуру. Петербургская гастрономия имеет свою идентичность: корюшка, карельская рыба, фермерские продукты Ленобласти, авторские шефы. «Паруса на крыше» (ул. Марата, 5, 6 этаж) — один из способов познать петербургский стиль жизни: еда + вид + музыка. Рейтинг 5,0.",
        "highlight": "Корюшка в апреле–мае, белые ночи в июне, туманная осень — Петербург каждый сезон разный. Еда меняется вместе с сезоном."
      },
      {
        "heading": "Маршрут «Петербург без музеев»",
        "body": "Утро: specialty-кофе. День: прогулка по дворам-колодцам центра. Некрасовский рынок. Обед в «Парусах» с видом на город. После: набережная Фонтанки. Вечер: театр или концерт. Ужин в ресторане с живой музыкой. Всё — без единого музея. Читайте о <a href='/blog/netipichnyy-peterburg-neobychnye-mesta' class='underline text-accent'>нетипичном Петербурге</a>."
      }
    ],
    "cta": { "text": "Забронировать обед с видом", "href": "/" }
  },
  {
    "slug": "kuda-poyti-peterburg-vesnoj",
    "title": "Куда пойти в Петербурге весной: лучшие идеи",
    "metaTitle": "Куда пойти в Петербурге весной 2026 | Паруса на крыше",
    "metaDescription": "Что делать в Петербурге весной: корюшка, парки, первые прогулки. Идеи на апрель–май.",
    "keywords": "куда пойти петербург весной, петербург весна что делать, весна петербург идеи",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Весна в Петербурге — радость после долгой зимы. Апрель пахнет корюшкой, май — сиренью. Расскажем, как использовать этот короткий период по максимуму.",
    "sections": [
      {
        "heading": "Что особенного весной в Петербурге",
        "body": "Апрель: таяние льда на Неве, первые солнечные дни, начало сезона корюшки. Май: сирень в Летнем саду и парках, первые длинные дни, 9 мая — фейерверк над Невой. Конец мая: начало белых ночей. Это переходный сезон — туристов ещё нет, но город уже ожил. Лучшее время для первого визита.",
        "list": [
          "Апрель: корюшка, первое тепло",
          "Май: сирень в парках, длинные дни",
          "9 мая: фейерверк над Невой",
          "Конец мая: начало белых ночей"
        ]
      },
      {
        "heading": "Корюшка — главный весенний повод",
        "body": "Каждый год в апреле–мае петербуржцы едят корюшку. Это ритуал: маленькая рыбка с запахом свежего огурца, жаренная в муке. В «Парусах на крыше» (ул. Марата, 5) корюшка появляется в меню в сезон. После зимы — первая свежая рыба года с видом на весенний Петербург с 6-го этажа. Рейтинг 5,0."
      }
    ],
    "cta": { "text": "Попробовать весеннее меню", "href": "/menu" }
  },
  {
    "slug": "vid-na-peterburg-s-isaaakievskogo-sobora",
    "title": "Вид на Петербург с Исаакиевского собора: что увидеть",
    "metaTitle": "Вид с Исаакиевского собора Петербург | Паруса на крыше",
    "metaDescription": "Вид с колоннады Исаакиевского собора: что открывается, как лучше подняться, альтернативы.",
    "keywords": "вид с исаакиевского собора петербург, колоннада исаакий вид, смотровая исаакий петербург",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_clouds.webp",
    "lead": "Колоннада Исаакиевского собора — одна из главных смотровых точек Петербурга. 362 ступени вверх — и перед вами 360° панорама исторического центра.",
    "sections": [
      {
        "heading": "Что видно с колоннады",
        "body": "На север: Дворцовая площадь, Эрмитаж, Нева, Петропавловская крепость. На восток: Казанский собор, Невский проспект, Смольный на горизонте. На запад: Финский залив (в ясный день). На юг: жилые кварталы, Новая Голландия. Это лучший «обзорный» вид Петербурга — статичный, без еды, но максимально широкий.",
        "list": [
          "Высота: около 43 метров над землёй",
          "Ступени: 362 — занимает 10–15 минут",
          "Время: лучше всего — золотой час и закат",
          "Билет: купите онлайн, меньше очередь"
        ]
      },
      {
        "heading": "Исаакий vs «Паруса» — разные виды",
        "body": "Колоннада Исаакия: открытый воздух, физические усилия, 45–60 минут. Вид на все стороны без еды. «Паруса на крыше» (ул. Марата, 5): ресторан, сидячий вид, авторская кухня, 300° панорама с акцентом на Казанский собор. Оба опыта стоят посещения. В один день: Исаакий → прогулка → ужин в «Парусах».",
        "highlight": "Уникальность Исаакия: открытый воздух на высоте. Уникальность «Парусов»: тот же вид с едой и музыкой. Не выбирайте — сделайте оба."
      }
    ],
    "cta": { "text": "Забронировать ужин с видом", "href": "/" }
  },
  {
    "slug": "restoran-s-vidom-na-tsentr-peterburga",
    "title": "Ресторан с видом на центр Петербурга",
    "metaTitle": "Ресторан с видом на центр Петербурга 2026 | Паруса на крыше",
    "metaDescription": "Ресторан с видом на исторический центр Санкт-Петербурга: панорама, купола, крыши.",
    "keywords": "ресторан вид на центр петербурга, ресторан панорама центр спб, вид на центр петербург ресторан",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Вид на центр Петербурга сверху — уникальный опыт. Крыши, купола, шпили — другой ракурс города, который меняет восприятие.",
    "sections": [
      {
        "heading": "Почему вид сверху другой",
        "body": "С уровня улицы виден только фасад. С высоты — объём, глубина, связи между частями города. Видно, как Невский проспект связывает Адмиралтейство с Александро-Невской лаврой. Видно, что Казанский собор — не отдельная точка, а часть городского центра. Пространственное понимание города приходит с высоты.",
        "list": [
          "С улицы: фасад",
          "С высоты: объём и связи",
          "Купола: их расположение относительно друг друга",
          "Горизонт: граница города и неба"
        ]
      },
      {
        "heading": "«Паруса» — лучший вид на центр",
        "body": "«Паруса на крыше» (ул. Марата, 5, 6 этаж) расположены в центре центра. 300° панорама: Казанский собор прямо перед окном, крыши Центрального района во все стороны, горизонт. Рейтинг 5,0 при 2 606 отзывах. Авторская кухня, живая музыка. Читайте о <a href='/blog/luchshie-vidy-peterburg-gde-smotret' class='underline text-accent'>лучших видах Петербурга</a>."
      }
    ],
    "cta": { "text": "Забронировать стол с видом", "href": "/" }
  },
  {
    "slug": "nebo-peterburg-krasivye-peizazhi",
    "title": "Небо Петербурга: самые красивые виды и пейзажи",
    "metaTitle": "Небо Петербурга — красивые виды 2026 | Паруса на крыше",
    "metaDescription": "Небо Санкт-Петербурга: как выглядит в разные сезоны, лучшие точки для наблюдения.",
    "keywords": "небо петербурга фото, красивое небо петербург, петербургское небо виды",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_clouds.webp",
    "lead": "Петербургское небо — особое явление. Широкий горизонт, низкое солнце, облака над куполами — всё это создаёт визуальную поэзию города.",
    "sections": [
      {
        "heading": "Небо Петербурга в разные сезоны",
        "body": "Белые ночи (июнь): небо светлое круглосуточно, тёплые нежно-синие ночи. Осень: тяжёлые свинцовые облака, резкий контраст с золотыми куполами. Зима: редкое синее небо над снегом, «финское» качество света. Весна: быстро меняющиеся облака, первые длинные дни. Каждый сезон — другая визуальная эстетика.",
        "list": [
          "Белые ночи: нет темноты — уникально",
          "Осень: драматические облака",
          "Зима: редкое синее небо с иллюминацией",
          "Весна: переменная облачность — фотогенично"
        ]
      },
      {
        "heading": "Небо с высоты «Парусов»",
        "body": "С 6-го этажа Olympic Plaza небо Петербурга видно во всём объёме. Не сдавленное фасадами соседних домов, а широкое, с куполами на переднем плане. «Паруса» (ул. Марата, 5) — единственный ресторан города, где этот вид с небом, куполами и крышами доступен за хорошим ужином. Рейтинг 5,0."
      }
    ],
    "cta": { "text": "Забронировать стол с видом на небо", "href": "/" }
  },
  {
    "slug": "marshrut-po-naberezhnykh-peterburg",
    "title": "Маршрут по набережным Петербурга",
    "metaTitle": "Маршрут по набережным Петербурга 2026 | Паруса на крыше",
    "metaDescription": "Пешеходный маршрут по набережным Санкт-Петербурга: Нева, Мойка, Фонтанка, каналы.",
    "keywords": "маршрут набережные петербург, прогулка набережными спб, набережные петербурга маршрут",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Набережные Петербурга — главные пешеходные артерии. Маршрут по набережным охватывает большую часть исторических достопримечательностей без единой экскурсии.",
    "sections": [
      {
        "heading": "Маршрут: 3–4 часа пешком",
        "body": "Старт: Стрелка Васильевского острова. Биржевой мост → Дворцовая набережная. Мимо Эрмитажа → Адмиралтейская набережная. Через Сенатскую площадь (Медный всадник) → набережная Мойки. Мойка до Невского. Канал Грибоедова → Спас-на-Крови. Финал: обратно к центру. Весь маршрут: 6–8 км, 3–4 часа неспешно.",
        "list": [
          "Стрелка В. О.: начальная точка",
          "Дворцовая набережная: Эрмитаж вдоль пути",
          "Набережная Мойки: исторические дворцы",
          "Канал Грибоедова: Спас-на-Крови"
        ]
      },
      {
        "heading": "Финал маршрута: ужин в «Парусах»",
        "body": "После набережных — подъём на 6-й этаж Olympic Plaza (ул. Марата, 5). С высоты видно весь пройденный маршрут: Нева, мосты, набережные — теперь в виде сверху. Авторская кухня, рейтинг 5,0, бизнес-ланч от 590 ₽. Читайте о <a href='/blog/progulka-po-nevskomy-marshrut' class='underline text-accent'>маршруте по Невскому</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин после прогулки", "href": "/" }
  },
  {
    "slug": "progulka-po-kanalam-peterburg",
    "title": "Прогулка по каналам Петербурга: маршрут",
    "metaTitle": "Прогулка по каналам Петербурга 2026 | Паруса на крыше",
    "metaDescription": "Маршрут прогулки по каналам Санкт-Петербурга: Мойка, Грибоедова, Крюков канал.",
    "keywords": "прогулка каналы петербург, маршрут по каналам спб, каналы петербург прогулка пешком",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Каналы Петербурга — это «венецианская» часть города. Отражения домов в воде, мосты каждые 200 метров, тихие набережные — совсем другая атмосфера, чем на Невском.",
    "sections": [
      {
        "heading": "Главные каналы для прогулки",
        "body": "Мойка: протекает через самые «аристократические» кварталы — Мойка 12 (квартира Пушкина), Юсуповский дворец. Канал Грибоедова: Спас-на-Крови, самое фотогеничное место. Крюков канал: тихий, малолюдный, рядом Мариинский театр. Зимняя канавка: маленькая, но известная — из «Пиковой дамы». Каждый канал — своя история.",
        "list": [
          "Мойка: квартира Пушкина, Юсуповский дворец",
          "Грибоедова: Спас-на-Крови — лучший вид",
          "Крюков: тихий, рядом Мариинский",
          "Зимняя канавка: самый маленький, из оперы"
        ]
      },
      {
        "heading": "Прогулка на кораблике vs пешком",
        "body": "На кораблике: другой ракурс — видишь парадные фасады домов у воды. Пешком: медленно, можно заходить в дворы, рассматривать детали. Оба формата хороши в разное время. Финал прогулки (любой): ужин в «Парусах» (ул. Марата, 5). С 6-го этажа видна часть пройденного маршрута с высоты. Рейтинг 5,0."
      }
    ],
    "cta": { "text": "Забронировать ужин после прогулки", "href": "/" }
  },
  {
    "slug": "marshrut-vykhodnyy-den-peterburg",
    "title": "Маршрут выходного дня по Петербургу",
    "metaTitle": "Маршрут выходного дня Петербург 2026 | Паруса на крыше",
    "metaDescription": "Маршрут для выходного дня в Санкт-Петербурге: что посмотреть, где поесть за 1 день.",
    "keywords": "маршрут выходного дня петербург, выходной день петербург план, субботний маршрут петербург",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Идеальный выходной в Петербурге: не пытаться увидеть всё, а выбрать 3–4 точки и провести у каждой достаточно времени.",
    "sections": [
      {
        "heading": "Маршрут субботы",
        "body": "10:00 — Завтрак в кофейне на Рубинштейна или Загородном. 11:00–13:30 — Эрмитаж (2–3 зала, без спешки). 13:30–15:00 — Обед в «Парусах на крыше» (ул. Марата, 5) — 590 ₽ бизнес-ланч. 15:00–18:00 — Невский проспект, Казанский собор, набережная Мойки. 18:00–20:00 — Свободное время (кофе, книжный магазин, Фонтанка). 20:00–22:30 — Ужин в ресторане с живой музыкой.",
        "list": [
          "10:00: завтрак в кофейне",
          "11:00: Эрмитаж — 2–3 зала",
          "13:30: обед в «Парусах» с видом",
          "20:00: ужин с живой музыкой"
        ]
      },
      {
        "heading": "Маршрут воскресенья",
        "body": "Воскресенье — медленный день. Поздний бранч (11:00). Прогулка по Петроградской или Васильевскому острову — менее туристические районы. Музей Фаберже или Анна Ахматова — небольшие, не изматывают. Вечерний ужин у Фонтанки. Читайте о <a href='/blog/kuda-sxodit-v-peterburge-v-vykhodnye' class='underline text-accent'>выходных в Петербурге</a>."
      }
    ],
    "cta": { "text": "Забронировать субботний ужин", "href": "/" }
  },
  {
    "slug": "utrennyy-peterburg-marshrut",
    "title": "Утренний Петербург: маршрут для ранних пташек",
    "metaTitle": "Утренний Петербург маршрут 2026 | Паруса на крыше",
    "metaDescription": "Петербург рано утром: маршрут для тех, кто встаёт в 7–8 утра. Пустые набережные и утренний город.",
    "keywords": "утренний петербург маршрут, петербург утром что делать, ранний петербург прогулка",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Ранний Петербург — особый. В 7–8 утра набережные пусты, каналы зеркальны, воздух свеж. Это другой город.",
    "sections": [
      {
        "heading": "Маршрут для раннего утра",
        "body": "07:00 — Набережная Невы у Дворцовой площади: почти никого. 07:30 — Кофе в круглосуточном кафе или кофейне, которая открывается рано. 08:00 — Канал Грибоедова: пусто, отражения. 08:30 — Казанский собор: утренняя служба, или просто зайти — тихо. 09:00 — Завтрак в ресторане с видом на просыпающийся город. Петербург в 7 утра — словно только для вас.",
        "list": [
          "07:00: пустая Дворцовая набережная",
          "08:00: канал Грибоедова — зеркальные отражения",
          "08:30: утренний Казанский",
          "09:00: завтрак с панорамой"
        ]
      },
      {
        "heading": "Завтрак в «Парусах» после утренней прогулки",
        "body": "«Паруса» (ул. Марата, 5) открываются на завтрак. Уточните время по телефону: +7 (812) 991-10-90. После прогулки по пустым набережным — ресторан с видом на просыпающийся город. Рейтинг 5,0. Читайте о <a href='/blog/zavtrak-s-vidom-na-peterburg-restoran' class='underline text-accent'>завтраке с видом</a>."
      }
    ],
    "cta": { "text": "Забронировать утренний завтрак", "href": "/" }
  },
  {
    "slug": "vechernyy-peterburg-marshrut-progulka",
    "title": "Вечерний Петербург: маршрут для прогулки",
    "metaTitle": "Вечерний Петербург маршрут прогулка 2026 | Паруса",
    "metaDescription": "Маршрут вечерней прогулки по Санкт-Петербургу: набережные, рестораны, подсветка.",
    "keywords": "вечерний петербург прогулка, маршрут вечер петербург, вечер петербург что делать куда идти",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Вечерний Петербург — когда включается подсветка соборов и набережные становятся особенно красивыми. Маршрут для тех, кто любит ходить пешком.",
    "sections": [
      {
        "heading": "Маршрут вечерней прогулки",
        "body": "19:00 — Выход от Казанского собора. Невский проспект в закатном свете. Мимо Гостиного двора → площадь Островского. Вниз по Садовой до Фонтанки. По набережной Фонтанки до улицы Марата. 20:30 — Ужин в «Парусах» (ул. Марата, 5, 6 этаж) с видом на вечерний город. После ужина — решать по настроению: набережная, мосты, или домой.",
        "list": [
          "19:00: Казанский + Невский в закатном свете",
          "19:45: Фонтанка пешком",
          "20:30: ужин в «Парусах»",
          "После: набережная или разводные мосты"
        ]
      },
      {
        "heading": "Почему этот маршрут работает",
        "body": "Прогулка + ужин = полноценный вечер с физической активностью и гастрономическим удовольствием. Маршрут линейный, не требует возвращаться назад. Финал в ресторане — естественная кульминация. Рейтинг 5,0."
      }
    ],
    "cta": { "text": "Забронировать вечерний ужин", "href": "/" }
  },
  {
    "slug": "marshrut-muzei-s-obedomy-peterburg",
    "title": "Маршрут по музеям Петербурга с обедом",
    "metaTitle": "Маршрут по музеям Петербурга с обедом 2026 | Паруса",
    "metaDescription": "Как совместить посещение музеев в Петербурге с хорошим обедом в панорамном ресторане.",
    "keywords": "музеи петербург с обедом, маршрут музеи петербург ресторан, эрмитаж обед петербург",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Музей и хороший обед — лучшее сочетание для дня в Петербурге. Разберём, как совместить это органично.",
    "sections": [
      {
        "heading": "Логика «музей + обед»",
        "body": "Музей утром: меньше людей, свежая голова. Обед после: переосмыслить увиденное. Это классический формат культурного дня. Важный момент: не ешьте в музейных кафе — они обычно перегружены и посредственны. Уйдите на 10–20 минут пешком и пообедайте нормально.",
        "list": [
          "Утром в музей: меньше людей",
          "Выйти на 15–20 минут пешком от музея",
          "Обед после: переосмыслить увиденное",
          "Не музейные кафе: обычно слабее и дороже"
        ]
      },
      {
        "heading": "Эрмитаж + обед в «Парусах»",
        "body": "Эрмитаж 10:00–13:00 → пешком 20 минут до ул. Марата, 5 → бизнес-ланч в «Парусах» от 590 ₽ → панорама Петербурга с 6-го этажа. После трёх часов в залах — это физически приятно и умственно оживляет. Рейтинг 5,0. Читайте о <a href='/blog/gde-poyest-posle-ermitazha-spb' class='underline text-accent'>ресторанах после Эрмитажа</a>."
      }
    ],
    "cta": { "text": "Забронировать обед", "href": "/" }
  },
  {
    "slug": "kulturnyy-marshrut-peterburg-za-den",
    "title": "Культурный маршрут по Петербургу за 1 день",
    "metaTitle": "Культурный маршрут Петербург за 1 день 2026 | Паруса",
    "metaDescription": "Культурный маршрут по Санкт-Петербургу за 1 день: театр, музей, выставка и ужин.",
    "keywords": "культурный маршрут петербург 1 день, культура петербург маршрут, искусство петербург за день",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Культурный день в Петербурге: утро — выставка, день — обед с видом на город, вечер — театр, ночь — ужин. Четыре акта одного дня.",
    "sections": [
      {
        "heading": "Четырёхактный культурный день",
        "body": "Утро (10:00–13:00): музей Фаберже или Русский музей — меньше людей, чем в Эрмитаже. Обед (13:00–15:00): «Паруса» (ул. Марата, 5) — бизнес-ланч от 590 ₽ с видом. Вечер (19:00–22:00): Мариинский или Михайловский театр. Ночь (22:30): ужин в ресторане после спектакля. Это петербургский день в полной мере.",
        "list": [
          "Утро: Фаберже или Русский музей",
          "Обед: «Паруса», 590 ₽, вид на город",
          "Вечер: театр",
          "Ночь: ужин после спектакля"
        ]
      },
      {
        "heading": "Почему именно так",
        "body": "Утро для музея: голова свежая, людей меньше. «Паруса» для обеда: лучшее соотношение цена/вид. Театр вечером: стандартное время спектаклей. Ужин после театра: эмоции ещё живые, хочется обсудить. Петербург для культурного дня идеален — всё компактно. Читайте о <a href='/blog/kuda-poyti-v-peterburge-vecherom' class='underline text-accent'>вечере в Петербурге</a>."
      }
    ],
    "cta": { "text": "Забронировать культурный обед", "href": "/" }
  },
  {
    "slug": "progulka-ot-kazanskogo-do-maraty",
    "title": "Прогулка от Казанского собора до улицы Марата",
    "metaTitle": "Прогулка Казанский собор — улица Марата | Паруса на крыше",
    "metaDescription": "Маршрут прогулки от Казанского собора до улицы Марата в Петербурге с достопримечательностями.",
    "keywords": "прогулка казанский марата петербург, маршрут от казанского до марата, казанский собор улица марата",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Прогулка от Казанского собора до улицы Марата — 15 минут пешком через самое сердце Петербурга. И в конце — подъём на 6-й этаж с видом на Казанский.",
    "sections": [
      {
        "heading": "Маршрут",
        "body": "От Казанского собора: по Невскому на восток. Мимо Гостиного двора. Налево на улицу Марата у Фонтанки. По Марата до дома 5 (Olympic Plaza). Подъём на 6-й этаж — «Паруса». Весь маршрут: 1,2 км, 15 минут. Из окон ресторана виден купол Казанского собора — откуда вы шли.",
        "list": [
          "Казанский собор: начало",
          "Невский проспект: главная улица",
          "Улица Марата: поворот с Невского у Фонтанки",
          "«Паруса» (Марата, 5): финал — вид на Казанский"
        ]
      },
      {
        "heading": "Эффект «круговой» прогулки",
        "body": "Вы стоите перед Казанским → через 15 минут смотрите на Казанский с высоты. Это «круговой» эффект: точка начала и конца маршрута одна, но виды совершенно разные. Рейтинг 5,0, бизнес-ланч от 590 ₽, рейтинг 5,0."
      }
    ],
    "cta": { "text": "Забронировать стол в финале маршрута", "href": "/" }
  },
  {
    "slug": "restorany-ryadom-s-russkim-muzeem-spb",
    "title": "Рестораны рядом с Русским музеем в Петербурге",
    "metaTitle": "Рестораны рядом с Русским музеем СПб 2026 | Паруса",
    "metaDescription": "Где поесть после Русского музея в Санкт-Петербурге: рестораны рядом с площадью Искусств.",
    "keywords": "рестораны русский музей петербург, где поесть после русского музея спб, ресторан рядом площадь искусств",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Русский музей — Михайловский дворец на площади Искусств. После трёх часов среди русского искусства — куда идти обедать?",
    "sections": [
      {
        "heading": "Рестораны у площади Искусств",
        "body": "Площадь Искусств и Михайловская улица: несколько ресторанов в историческом контексте. Итальянские и европейские рестораны на Итальянской улице. Садовая и Невский: 5–10 минут пешком — более широкий выбор. Улица Марата: 15 минут пешком — лучший ресторанный квартал зоны.",
        "list": [
          "Площадь Искусств: атмосферно, ограниченно",
          "Итальянская улица: несколько хороших вариантов",
          "Садовая–Невский: 5–10 мин, широкий выбор",
          "Улица Марата: 15 мин, «Паруса» с видом"
        ]
      },
      {
        "heading": "«Паруса» после Русского музея",
        "body": "15 минут пешком от площади Искусств до ул. Марата, 5. Подъём на 6-й этаж. Панорама: теперь вы видите Петербург с высоты — город, чьё искусство вы только что смотрели. Бизнес-ланч от 590 ₽. Рейтинг 5,0. Читайте о <a href='/blog/marshrut-muzei-s-obedomy-peterburg' class='underline text-accent'>маршрутах с музеями и обедом</a>."
      }
    ],
    "cta": { "text": "Забронировать обед после музея", "href": "/" }
  },
  {
    "slug": "restorany-ryadom-s-mariinskim-teatrom-spb",
    "title": "Рестораны рядом с Мариинским театром в СПб",
    "metaTitle": "Рестораны рядом с Мариинским театром СПб 2026 | Паруса",
    "metaDescription": "Рестораны рядом с Мариинским театром в Петербурге: где поесть до и после спектакля.",
    "keywords": "рестораны мариинский театр петербург, где поесть у мариинского спб, ресторан до после мариинского",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "Мариинский театр — в Коломне, на Театральной площади. Рестораны рядом — отдельная история.",
    "sections": [
      {
        "heading": "Рестораны у Мариинского",
        "body": "Непосредственно у Мариинского: несколько ресторанов на Театральной площади и набережной Мойки. Качество — среднее, рассчитаны на театральную публику. Для хорошего ужина после спектакля: лучше уехать на такси (15 минут) в центр. «Паруса» (ул. Марата, 5) — правильный выбор для ужина после Мариинского.",
        "list": [
          "У Мариинского: среднее качество",
          "15 минут на такси: центр",
          "«Паруса»: лучший вариант для ужина",
          "Спектакль заканчивается 21:00–22:00"
        ]
      },
      {
        "heading": "Культурный вечер в «Парусах»",
        "body": "Мариинский + «Паруса» = культурный вечер на два акта. Балет или опера → панорама города за ужином. Рейтинг 5,0. Читайте о <a href='/blog/restoran-posle-spektaklya-mariinski' class='underline text-accent'>ужине после Мариинского</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин после театра", "href": "/" }
  },
  {
    "slug": "gde-poyest-turistam-peterburg-top",
    "title": "Где поесть туристам в Петербурге: честный гид",
    "metaTitle": "Где поесть туристам в Петербурге 2026 | Паруса на крыше",
    "metaDescription": "Честный гид для туристов: где поесть в Петербурге, как избежать туристических ловушек.",
    "keywords": "где поесть туристам петербург, туристу где поесть спб, рестораны для туристов петербург",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "Турист в Петербурге легко попадёт в ловушку: красивый ресторан у Невского с двуязычным меню и завышенными ценами. Расскажем, как этого избежать.",
    "sections": [
      {
        "heading": "Признаки туристической ловушки",
        "body": "Меню на 5–10 языках сразу. Расположение прямо у главной достопримечательности. Официант у входа зазывает. Цены выше средних на 30–50% при среднем качестве. Отзывы преимущественно от иностранцев. Это не значит «плохо» — но значит «не лучший выбор».",
        "list": [
          "Меню на 10 языках: туристический формат",
          "Расположение прямо у достопримечательности",
          "Зазывала у входа: плохой знак",
          "Цены без логики: платите за локацию"
        ]
      },
      {
        "heading": "Стратегия для туриста",
        "body": "Уйдите на 2–3 улицы от Невского. Ищите рестораны с Яндекс-рейтингом 4,5+ при 200+ отзывах. Бизнес-ланч в будни — честная цена. «Паруса» (ул. Марата, 5, 6 этаж): 15 минут от Невского, рейтинг 5,0 при 2 606 реальных отзывах. Здесь едят и местные, и туристы — признак честного заведения.",
        "highlight": "Хороший тест: если за соседними столиками сидят петербуржцы и говорят по-русски — ресторан настоящий. Если все гости — туристы — подумайте дважды."
      }
    ],
    "cta": { "text": "Забронировать стол у настоящего ресторана", "href": "/" }
  },
  {
    "slug": "chto-poprobovat-poyest-peterburg",
    "title": "Что обязательно попробовать поесть в Петербурге",
    "metaTitle": "Что обязательно попробовать в Петербурге 2026 | Паруса",
    "metaDescription": "Гастрономический минимум для туриста в Петербурге: что нужно попробовать из еды.",
    "keywords": "что попробовать петербург еда, гастрономический минимум петербург, петербург еда что обязательно",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Гастрономический минимум для туриста в Петербурге: что нужно съесть обязательно, чтобы понять кухню города.",
    "sections": [
      {
        "heading": "Гастрономический минимум Петербурга",
        "body": "Корюшка (апрель–май): петербургская рыба номер один. Если в сезон — обязательно. Бульон с пирожком: в любое время, классика. Морепродукты: карельская форель и лосось, гребешки. Авторский десерт: несколько ресторанов делают действительно интересные десерты. Кофе specialty: петербургская кофейная сцена — одна из лучших в России.",
        "list": [
          "Корюшка: апрель–май — обязательно",
          "Карельская форель: свежая, не замороженная",
          "Авторский десерт: в хорошем ресторане",
          "Specialty-кофе: в правильной кофейне"
        ]
      },
      {
        "heading": "Где попробовать всё это",
        "body": "Корюшка: в сезон в «Парусах» (ул. Марата, 5). Морепродукты: авторское меню «Парусов». Авторский десерт: «Паруса» — часть авторского меню. Рейтинг 5,0, работают с 2009 года. Читайте о <a href='/blog/lokal-produkty-severo-zapad-bluda' class='underline text-accent'>локальных продуктах Северо-Запада</a>."
      }
    ],
    "cta": { "text": "Попробовать петербургскую кухню", "href": "/menu" }
  },
  {
    "slug": "restorany-russkaya-kukhnya-turisty-spb",
    "title": "Рестораны с русской кухней для туристов в СПб",
    "metaTitle": "Рестораны с русской кухней для туристов СПб 2026 | Паруса",
    "metaDescription": "Где попробовать русскую кухню туристу в Петербурге: настоящие рестораны без туристической наценки.",
    "keywords": "рестораны русская кухня туристы спб, русская кухня ресторан петербург, где попробовать русскую кухню спб",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Туристы часто хотят попробовать «настоящую русскую кухню». Но «русская кухня для туристов» — это одно, а реальная петербургская гастрономия — другое.",
    "sections": [
      {
        "heading": "Что такое настоящая русская кухня",
        "body": "Классическая: щи, борщ, пельмени, блины, солянка, котлеты. Это хорошая кухня, но в Петербурге она не очень отличается от любого другого российского города. Петербургская кухня: акцент на рыбе и морепродуктах (карельская форель, корюшка, гребешки), использование местных продуктов (ленинградские грибы, карельские ягоды). Это интереснее «туристической» версии.",
        "list": [
          "Классическая: борщ, пельмени, блины",
          "Петербургская: рыба, морепродукты, ягоды",
          "Авторская: петербургская + современный подход",
          "Лучший выбор для туриста: авторская петербургская"
        ]
      },
      {
        "heading": "«Паруса» как гастрономическое знакомство с Петербургом",
        "body": "«Паруса» (ул. Марата, 5) работают в жанре авторской кухни с северо-западными продуктами. Это не «русская кухня для туристов» — это настоящая петербургская гастрономия. Карельская рыба, локальные морепродукты, авторские десерты. С видом на город с 6-го этажа. Рейтинг 5,0. Читайте о <a href='/blog/lokal-produkty-severo-zapad-bluda' class='underline text-accent'>локальных продуктах</a>."
      }
    ],
    "cta": { "text": "Попробовать петербургскую кухню", "href": "/menu" }
  },
  {
    "slug": "peterburg-pervyy-raz-kuda-poyti",
    "title": "Петербург в первый раз: куда пойти и что увидеть",
    "metaTitle": "Петербург в первый раз — что посмотреть 2026 | Паруса",
    "metaDescription": "Петербург для первого посетителя: что обязательно, что пропустить, куда поесть.",
    "keywords": "петербург первый раз что посмотреть, впервые в петербурге что делать, первый раз в петербурге",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Первый раз в Петербурге — огромный город, масса достопримечательностей и риск потерять 3 дня на очереди в Эрмитаж. Как распорядиться временем правильно?",
    "sections": [
      {
        "heading": "Что обязательно в первый раз",
        "body": "Эрмитаж (2–3 часа, не весь). Казанский собор. Прогулка по Невскому от Адмиралтейства. Набережная Невы — Дворцовая набережная. Спас-на-Крови. Стрелка Васильевского острова. Один ужин с видом на город. Этого достаточно для 2 дней.",
        "list": [
          "Эрмитаж: 2–3 часа, не весь",
          "Казанский собор: снаружи и внутри",
          "Набережная Невы: прогулка обязательна",
          "Ужин с видом: кульминация первого дня"
        ]
      },
      {
        "heading": "Первый ужин: «Паруса»",
        "body": "Первый ужин в незнакомом городе задаёт тон всей поездке. «Паруса» (ул. Марата, 5) дают правильный старт: вид на весь центр с 6-го этажа помогает «собрать» всё, что видели за день, и понять географию города. Авторская кухня, рейтинг 5,0, живая музыка. Читайте о <a href='/blog/marshrut-peterburg-novichku-guide' class='underline text-accent'>маршруте для новичка</a>."
      }
    ],
    "cta": { "text": "Забронировать первый ужин в Петербурге", "href": "/" }
  },
  {
    "slug": "kuda-pojti-v-peterburge-esli-videl-vse",
    "title": "Куда пойти в Петербурге, если всё уже видел",
    "metaTitle": "Куда пойти в Петербурге если всё видел 2026 | Паруса",
    "metaDescription": "Нетривиальные места и занятия в Петербурге для тех, кто уже видел Эрмитаж и Петергоф.",
    "keywords": "куда пойти петербург если всё видел, нетривиальный петербург, петербург не туристу что делать",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "«Я был в Петербурге пять раз и видел всё». Петербург невозможно исчерпать. Расскажем, что открывается при более глубоком знакомстве.",
    "sections": [
      {
        "heading": "Петербург для «ветеранов»",
        "body": "Малые музеи: музей Фаберже (часто недооценён), театральный музей, музей блокады. Аутентичные кварталы: Петроградская сторона, Коломна, Приморский. Рестораны «не для туристов»: заведения, куда ходят местные — на Рубинштейна, Марата, Загородном. Архитектурные экскурсии в стиле модерн. «Новая Голландия» летом. Дворы-колодцы.",
        "list": [
          "Музей Фаберже: удивляет даже искушённых",
          "Коломна: тихий район у Мариинского",
          "Аутентичные рестораны: куда ходят местные",
          "Дворы-колодцы: неисчерпаемый ресурс"
        ]
      },
      {
        "heading": "«Паруса» как ещё не пройденный опыт",
        "body": "Среди «ветеранов» Петербурга немало тех, кто не был в «Парусах». Ресторан на 6-м этаже Olympic Plaza (ул. Марата, 5) — для жителей города тоже часто «новое место». 300° панорама не надоедает с годами. Рейтинг 5,0 при 2 606 отзывах означает, что это место узнают снова. Читайте о <a href='/blog/peterburg-vyezd-marshut' class='underline text-accent'>нетипичном Петербурге</a>."
      }
    ],
    "cta": { "text": "Открыть Петербург с новой стороны", "href": "/" }
  },
  {
    "slug": "peterburgskaya-vesna-progulki-idei",
    "title": "Петербургская весна: прогулки и идеи для пары",
    "metaTitle": "Петербургская весна прогулки и идеи 2026 | Паруса",
    "metaDescription": "Весна в Санкт-Петербурге: лучшие идеи для прогулок и ужинов в апреле–мае.",
    "keywords": "петербург весна прогулки, весенний петербург что делать, идеи петербург апрель май",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Петербург весной освобождается от зимы и туристов ещё нет. Это лучшее время для неспешного знакомства с городом.",
    "sections": [
      {
        "heading": "Весенние прогулки в Петербурге",
        "body": "Апрель: Ботанический сад (первые цветы), Елагин остров (сирень позже), набережная когда начинает таять лёд. Май: Летний сад (открывается после зимы), Петергоф (фонтаны запускают в мае), Павловск (парк с первой зеленью). Корюшка — в любое время апреля–мая.",
        "list": [
          "Апрель: Ботанический сад, набережная",
          "Май: Летний сад, Петергоф",
          "Корюшка: апрель–май",
          "Велосипед: весной удобно по набережным"
        ]
      },
      {
        "heading": "Весенний ужин в «Парусах»",
        "body": "«Паруса» (ул. Марата, 5) весной особенно хороши: первые тёплые вечера, открытие летней террасы, корюшка в меню. Бизнес-ланч от 590 ₽, живая музыка по расписанию. Весенний Петербург с 6-го этажа — с первой зеленью и высоким небом. Рейтинг 5,0. Читайте о <a href='/blog/kuda-sxodit-v-peterburge-v-vykhodnye' class='underline text-accent'>выходных в Петербурге</a>."
      }
    ],
    "cta": { "text": "Забронировать весенний ужин", "href": "/" }
  },
  {
    "slug": "gid-po-restoranam-turistu-peterburg",
    "title": "Гид по ресторанам для туристов в Петербурге",
    "metaTitle": "Гид по ресторанам для туристов Петербург 2026 | Паруса",
    "metaDescription": "Путеводитель по ресторанам Петербурга для туристов: как выбрать, где искать, что ожидать.",
    "keywords": "гид рестораны туристу петербург, путеводитель рестораны спб, ресторанный гид петербург 2026",
    "date": "2026-06-10",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Полный гид по ресторанам Петербурга для туриста: как выбрать, чего ожидать, где искать лучшее.",
    "sections": [
      {
        "heading": "Ресторанная карта Петербурга",
        "body": "Центральный район: самый богатый на рестораны. Улицы Марата, Загородный, Рубинштейна — нетуристический центр. Невский: туристические форматы, можно найти хорошее. Петроградская: для местных. Васильевский: студенческий. «Севкабель»: летом — молодёжно. Каждый район — своя ресторанная культура.",
        "list": [
          "Центр: главный ресторанный кластер",
          "Марата–Рубинштейна–Загородный: нетуристический лучший выбор",
          "Петроградская: аутентичность",
          "Невский: удобно, но туристично"
        ]
      },
      {
        "heading": "Топ-рекомендация для туриста",
        "body": "«Паруса на крыше» (ул. Марата, 5) — один обед или ужин здесь лучше объяснит петербургскую ресторанную культуру, чем 10 случайных визитов. Рейтинг 5,0 при 2 606 отзывах — показатель надёжности. Авторская кухня, вид, живая музыка. Бизнес-ланч от 590 ₽. Это и есть настоящий Петербург за столом."
      }
    ],
    "cta": { "text": "Начать знакомство с Петербургом в «Парусах»", "href": "/" }
  }
];
